import React from "react";
import {
  Container,
  Flex,
  Title,
  Text,
  Accordion,
  Divider,
} from "@mantine/core";
import {
  CustomContentGrid,
  CustomBackground,
  CustomSplitTitle,
} from "@components/custom";
import { CustomFooter } from "@/src/components/footer/footer";

// FAQ data
const faqItems = [
  {
    question: "What does ACBRANDS actually do?",
    answer:
      "We help challenger food and drink brands secure listings, grow distribution, and drive sales across wholesale, independents, and foodservice.",
  },
  {
    question: "What type of brands do you work with?",
    answer:
      "We work with emerging, founder-led brands that have a clear category fit and product people want—brands like Freja and Dalston’s.",
  },
  {
    question: "How is ACBRANDS different from a traditional sales agency?",
    answer:
      "We plug in as your sales team—whether you’re just starting out or already established, we adapt to your brand and build momentum your way.",
  },
  {
    question: "What kind of results can you deliver?",
    answer:
      "We deliver new listings, wider distribution, repeat orders, and a clear, trackable sales pipeline.",
  },
  {
    question: "Do you work with supermarkets?",
    answer:
      "No—we focus on wholesale, independents, and foodservice, where challenger brands can build stronger, more sustainable growth.",
  },
  {
    question: "Which wholesalers or foodservice partners do you work with?",
    answer:
      "We work directly with leading UK wholesalers and OOH operators, helping brands get in front of the right buyers and secure listings.",
  },
  {
    question: "How do you charge for your services?",
    answer:
      "We charge a monthly retainer with performance incentives, so we’re paid to deliver real growth—not just activity.",
  },
  {
    question: "How long does it take to see results?",
    answer:
      "Most brands start seeing listings and early orders within a few months, with consistent growth building from there.",
  },
  {
    question: "Will you represent competing brands?",
    answer:
      "No—we don’t work with direct competitors, ensuring full focus and protecting your position in the market.",
  },
  {
    question: "How do we get started?",
    answer:
      "We start with a straight conversation to understand your brand, your goals, and whether we’re the right partner to scale your growth.",
  },
];

interface FaqProps {
  isNotHomePage?: boolean;
}

export const Faq: React.FC<FaqProps> = ({ isNotHomePage = false }) => {
  return (
    <>
      <CustomBackground />
      <Container mt={0} mb={0} style={isNotHomePage ? { paddingTop: '85px' } : undefined}>
        <CustomContentGrid >
          <CustomContentGrid.Main>
            <Flex justify="space-between" align="center" mb="xl">
              <Title 
                order={2} 
                style={{
                  position: 'absolute',
                  width: '1px',
                  height: '1px',
                  padding: 0,
                  margin: '-1px',
                  overflow: 'hidden',
                  clip: 'rect(0, 0, 0, 0)',
                  whiteSpace: 'nowrap',
                  border: 0
                }}
              >
                FAQs
              </Title>
              <CustomSplitTitle
                order={2}
                partA="FAQ"
                partB=""
                partAStyle={{ color: '#000' }}
                partBStyle={{ color: '#000' }}
                aria-hidden="true"
                alignCenter
                textAlign="center"
              />
            </Flex>
            <Text ta="center" size="xl" mb="xl">Everything you need to know about working with ACBRANDS.</Text>
            <Accordion
              variant="separated"
              radius="lg"
              chevronPosition="right"
              multiple={false}
              mb="xl"
              styles={{
                root: {
                  background: 'transparent',
                  border: '2px solid #A4F9AD',
                  borderRadius: 24,
                  color: '#000',
                },
                item: {
                  background: 'transparent',
                  color: '#000',
                  border: 'none', // Remove default item border
                },
                control: {
                  color: '#000',
                },
                panel: {
                  color: '#000',
                },
                chevron: {
                  width: 36,
                  height: 36,
                  minWidth: 36,
                  minHeight: 36,
                  fontSize: 32,
                  // Add these lines to override Mantine's default SVG sizing:
                  '& svg': {
                    width: 36,
                    height: 36,
                  },
                },
              }}
            >
              {faqItems.map((item, idx) => (
                <Accordion.Item value={item.question} key={item.question}>
                  <Accordion.Control>
                    <Text fw={700} size="xl">{item.question}</Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <Text>{item.answer}</Text>
                  </Accordion.Panel>
                  {/* {idx < faqItems.length - 1 && (
                    <Divider my="md" variant="dashed" />
                  )} */}
                </Accordion.Item>
              ))}
            </Accordion>
          </CustomContentGrid.Main>
        </CustomContentGrid>
      </Container>
      <CustomFooter />
    </>
  );
};
